import { jsx as _jsx } from "react/jsx-runtime";
import { Link as RouterLink } from 'react-router-dom';
import { useAuthToken } from '@tribeplatform/react-sdk/hooks';
import { Link as LinkUI } from '@tribeplatform/react-ui-kit/Link';
import { getIsInternal, getLinkRel, getLinkTarget, parseHref } from './utils';
export const Link = ({ href, target, trusted, children, variant = 'inherit', ...props }) => {
    const { data: { networkPublicInfo }, } = useAuthToken();
    const parsedHref = parseHref(href, networkPublicInfo);
    const isInternal = getIsInternal(parsedHref);
    const linkTarget = getLinkTarget(target, isInternal);
    const isTrusted = trusted || isInternal;
    const linkRel = getLinkRel(linkTarget, isTrusted);
    if (!href) {
        return (_jsx(LinkUI, { variant: variant, ...props, children: children }, void 0));
    }
    if (isInternal) {
        return (_jsx(LinkUI, { as: RouterLink, to: parsedHref, variant: variant, ...(linkTarget ? { target: linkTarget } : {}), ...(linkRel ? { rel: linkRel } : {}), ...props, children: children }, void 0));
    }
    return (_jsx(LinkUI, { href: parsedHref, variant: variant, ...(linkTarget ? { target: linkTarget } : {}), ...(linkRel ? { rel: linkRel } : {}), ...props, children: children }, void 0));
};
//# sourceMappingURL=Link.js.map